import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.796 20l-.23-2.016c-.187.01-.376.016-.566.016-3.8 0-7-2.133-7-5h2c0 1.551 2.173 3 5 3 .113 0 .226-.002.337-.007L12.108 14H8.792l1.904-10H5a1 1 0 00-1 1v14a1 1 0 001 1h7.796zm2.014 0H19a1 1 0 001-1V5a1 1 0 00-1-1h-6.268l-1.524 8h2.684l.419 3.65C15.928 15.128 17 14.09 17 13h2c0 2.195-1.874 3.959-4.458 4.666L14.81 20zM5 2h14a3 3 0 013 3v14a3 3 0 01-3 3H5a3 3 0 01-3-3V5a3 3 0 013-3zm1 5h2v3H6V7zm10 0h2v3h-2V7z"
    />
  </svg>
);
